import { Ecosystem } from "@protos/sca/v1/sca";

export const pttSupportedEcosystems: Array<Ecosystem> = [
  Ecosystem.pypi,
  Ecosystem.swiftpm,
  Ecosystem.npm,
  Ecosystem.maven,
];

/*
 * Internal method to get the manifest path from a lockfile path. Ideally, we should annotate
 * dependencies with their manifest path but until then, we need to infer it from the lockfile path.
 *
 * TODO: SC-1681 - Annotate dependencies with their manifest path
 *
 * @param manifestPath - The path to the manifest file
 */
export const getManifestPath = (filePath: string) => {
  const manifestPathLockfileMap = new Map<string, string>([
    ["requirements.txt", "requirements.txt"],
    ["gradle.lockfile", "build.gradle"],
    ["package-lock.json", "package.json"],
    ["yarn.lock", "package.json"],
    ["Package.resolved", "Package.swift"],
    ["maven_dep_tree.txt", "pom.xml"],
  ]);

  const splitPath = filePath.split("/");
  const lockfileName = splitPath[splitPath.length - 1];
  const manifestFile = manifestPathLockfileMap.get(lockfileName);

  if (!manifestFile) {
    return null;
  }

  if (splitPath.length === 1) {
    return manifestFile;
  } else {
    return splitPath.slice(0, -1).join("/") + "/" + manifestFile;
  }
};
